// Matchup-first, league-fallback loader for the Game News surfaces. Keeps
// relevance HONEST: matchup-specific items are labelled "matchup"; when there
// are none we fall back to league items labelled "league" (never presented as
// matchup-specific). `fetcher` is injected (TurfTalk.news) so this is unit
// testable without network.
import { normalizeNewsFeed, buildNewsQuery } from "./news";

export async function loadGameNews(fetcher, { gameId = null, league = null, team = null, limit = 5 } = {}) {
  const tryFetch = async (params) => normalizeNewsFeed(await fetcher(buildNewsQuery({ ...params, limit })));

  let matchup = null;
  if (gameId) {
    matchup = await tryFetch({ gameId });
    if (matchup.items.length) return { ...matchup, mode: "matchup" };
  }
  if (league || team) {
    const leagueFeed = await tryFetch({ league, team });
    if (leagueFeed.items.length) return { ...leagueFeed, mode: "league" };
    // Neither matchup nor league returned items — surface the league feed's
    // honest status (empty/unavailable), still labelled league.
    return { ...leagueFeed, mode: "league" };
  }
  if (matchup) return { ...matchup, mode: "matchup" };
  return { items: [], status: "unavailable", updatedAt: null, mode: "none" };
}

// Human label for the news mode so the UI never fakes matchup relevance.
export function modeLabel(mode, { awayAbbr, homeAbbr, league } = {}) {
  if (mode === "matchup") {
    return awayAbbr && homeAbbr ? `${awayAbbr} @ ${homeAbbr} news` : "Matchup news";
  }
  if (mode === "league") return league ? `${String(league).toUpperCase()} news` : "League news";
  return "Game news";
}

export function modeSubnote(mode, { awayAbbr, homeAbbr } = {}) {
  if (mode === "league") {
    const m = awayAbbr && homeAbbr ? `${awayAbbr} @ ${homeAbbr}` : "this matchup";
    return `No ${m}-specific stories yet — showing league headlines.`;
  }
  return null;
}
